import { ApiProperty } from "@nestjs/swagger";

export class AsnItemsInfo {
    asnItemId: number;
    asnId: number;
    poId: number;
    itemId: number;  
    sizeId: number;
    poQuantity: number;
    asnQuantity: number; 
    createdAt: Date;
    createdUser: string | null;
    updatedAt: Date;
    updatedUser: string | null;
    versionFlag: number;  
}